module.exports = __webpack_public_path__ + "static/media/right.de82477f.jpg";